import { zodResolver } from "@hookform/resolvers/zod";
import { StartAppointmentDtoSchema } from "@myapp/contract";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { useStartAppointment } from "../../../entities/appointment";
import { DurationSpinner } from "../../../shared/ui/controls/DurationSpinner/DurationSpinner";
import Modal from "../../../shared/ui/overlay/Modal/Modal";

const FormSchema = StartAppointmentDtoSchema;

type FormValues = z.infer<typeof FormSchema>;

type Props = {
  show: boolean;
  setShow: (show: boolean) => void;
  appointmentId: string;
  workOrderId?: string;
  plannedTravelDuration: number;
  onSuccess: () => void;
};

export const StartAppointmentModal = ({
  show,
  setShow,
  appointmentId,
  workOrderId,
  plannedTravelDuration,
  onSuccess,
}: Props) => {
  const start = useStartAppointment();

  const { control, handleSubmit, reset, formState: { errors } } = useForm<FormValues>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      actualTravelDuration: plannedTravelDuration,
    },
  });

  useEffect(() => {
    if (show) {
      reset({ actualTravelDuration: plannedTravelDuration });
    }
  }, [show, plannedTravelDuration, reset]);

  const onSubmit = (values: FormValues) => {
    start.mutate(
      { id: appointmentId, workOrderId, dto: { actualTravelDuration: values.actualTravelDuration } },
      { onSuccess },
    );
  };

  return (
    <Modal
      show={show}
      setShow={setShow}
      title="Arbeit starten"
      submitButton={{ onSubmit: handleSubmit(onSubmit), title: 'Arbeit starten', isPending: start.isPending }}
    >
      <div className="flex flex-col gap-4 w-full">
        <Controller
          name="actualTravelDuration"
          control={control}
          render={({ field }) => (
            <DurationSpinner
              label="Anfahrt (min)"
              value={field.value}
              onChange={field.onChange}
              error={errors.actualTravelDuration?.message}
            />
          )}
        />
      </div>
    </Modal>
  );
};
